import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId/acquisition')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/acquisition-page')),
  staticData: { titleKey: 'acquisition' },
});
